<template>
<div>
    <v-dashboardevm v-if="chainId == 9001"></v-dashboardevm>
    <v-dashboardevmtest v-if="chainId == 9000"></v-dashboardevmtest>
    <v-dashboardzk v-if="chainId == 280"></v-dashboardzk>
    <v-dashboardzkmain v-if="chainId == 324"></v-dashboardzkmain>
    <v-dashboardscroll v-if="chainId == 534353"></v-dashboardscroll>
    <v-dashboardscrollsepolia v-if="chainId == 534351"></v-dashboardscrollsepolia>
</div>
</template>

<script>
    export default {
        data() {
            return {
                chainId:'',
            }
        },
        mounted(){
            this.chainId = localStorage.getItem('chainId') || 9001
            if(this.chainId == 534352){
                localStorage.setItem('chainId',324)
                window.location.reload();
            }
        },
    }
</script> 